package ui.user

import androidx.compose.runtime.*
import androidx.compose.ui.text.style.*
import androidx.compose.ui.unit.*
import common.frontend.api.*
import kotlinx.datetime.*
import org.ssoft.common.tools.*
import provider.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*
import tools.*
import ui.widget.*


interface UserListingScope {

    val vm: UserListingVM
    val action: (UserListingVM.Action) -> Unit
    val nav: Navigation
    val login: Io.User
    val args: UserListingArgs
    val headerSpecs: ListingSpecs<Wrapper.Item>

    companion object {

        private val headerItemLastLogin by lazy {
            ListingSpecs.Item<Wrapper.Item>(title = Res.string.user_listing__item_login_date, width = 100.dp) {
                if (it.data.loginDt.date == LocalDate.EMPTY) "?"
                else it.data.loginDt.date.formatFromRes()
            }
        }

        private val headerSpecsInCompany = ListingSpecs.create<Wrapper.Item>(
            ListingSpecs.Item(title = Res.string.user_listing__item_id, width = 50.dp, align = TextAlign.Center) { ListingSpecs.trimmedId(it.data.id) },
            ListingSpecs.Item(title = Res.string.user_listing__item_name, width = 200.dp) { it.data.name },
            headerItemLastLogin
        )

        private val headerSpecsAll = ListingSpecs.create<Wrapper.Item>(
            ListingSpecs.Item(title = Res.string.user_listing__item_id, width = 50.dp, align = TextAlign.Center) { ListingSpecs.trimmedId(it.data.id) },
            ListingSpecs.Item(title = Res.string.user_listing__item_name, width = 200.dp) { it.data.name },
            ListingSpecs.Item(title = Res.string.user_listing__item_name_company, width = 200.dp) { it.data.name_company },
            headerItemLastLogin
        )

        @Composable
        fun rememberScope(): UserListingScope {
            val account = LocalAccountProvider.current
            val nav = LocalNavigation.current
            val args = LocalNavigationArgs.current
            val arg = args.rememberArgs(UserListingArgs::class)
            val vm = nav.viewModel(UserListingVM::class, "${arg.companyId}:${arg.showAll}")
            val action = UserListingVM.Action.rememberAction(vm)
            return remember {
                object : UserListingScope {
                    override val vm: UserListingVM
                        get() = vm
                    override val action: (UserListingVM.Action) -> Unit
                        get() = action
                    override val nav: Navigation
                        get() = nav
                    override val login: Io.User
                        get() = account.current!!
                    override val args: UserListingArgs
                        get() = args.args<UserListingArgs>()
                    override val headerSpecs: ListingSpecs<Wrapper.Item>
                        get() = if (arg.showAll) headerSpecsAll else headerSpecsInCompany
                }.also {
                    vm.init(it)
                }
            }
        }
    }

    class Wrapper(listing: Io.ListingUser) : EFieldList<Io.ListingUser.Item, Wrapper.Item>(
        items = listing.items,
        onBindEntry = { Item(it) }
    ) {
        class Item(
            override val data: Io.ListingUser.Item,
            override val key: String = data.id.toString(),

            ) : Entry<Io.ListingUser.Item> {
            private var origin = data.copy()

            val name: EFieldTextString = EFieldTextString(
                property = data::name,
                condition = { it.trim().takeIf { it.length > 3 } },
                onChange = { makeChange() },
                onErr = { makeChange() })

            var change by mutableStateOf(false)
                private set

            private fun makeChange() {
                if (name.err) {
                    change = false
                } else if (origin.name != data.name) {
                    change = true
                }
            }
        }
    }
}
